import classNames from 'classnames'

import Button from '../../Button'
import { SelectTags } from '../SelectTags'

import * as styles from './SelectButton.module.css'

function SelectButton(props) {
  const {
    afterIconProps,
    beforeIconProps,
    className,
    disabled,
    elementRef,
    entity,
    error,
    height,
    isGrey = true,
    isOpen,
    isSkeleton,
    listType,
    qaName,
    showTextTooltip,
    tags,
    text,
    textClassName,
    tooltip,
    type,
  } = props

  if (type === 'text') {
    const btnTextClass = classNames(styles.text, className)

    return (
      <Button.Text
        afterIconProps={afterIconProps}
        beforeIconProps={beforeIconProps}
        className={btnTextClass}
        disabled={disabled}
        elementRef={elementRef}
        height={24}
        isActive={isOpen}
        isGrey={isGrey}
        isSkeleton={isSkeleton}
        qaName={qaName}
        text={text}
        textClassName={textClassName}
        onClick={props.onClick}
      />
    )
  }

  if (type === 'outlined') {
    return (
      <Button.Outlined
        afterIconProps={afterIconProps}
        className={className}
        disabled={disabled}
        elementRef={elementRef}
        height={height}
        isActive={isOpen}
        isGrey={isGrey}
        isSkeleton={isSkeleton}
        qaName={qaName}
        text={text}
        onClick={props.onClick}
      />
    )
  }

  if (type === 'white') {
    return (
      <Button.White
        shadowed
        afterIconProps={afterIconProps}
        beforeIconProps={beforeIconProps}
        className={className}
        disabled={disabled}
        elementRef={elementRef}
        height={height}
        isActive={isOpen}
        isGrey={isGrey}
        isSkeleton={isSkeleton}
        qaName={qaName}
        showTextTooltip={showTextTooltip}
        text={text}
        textClassName={textClassName}
        onClick={props.onClick}
        onCloseTag={props.onCloseTag}
      >
        <SelectTags
          entity={entity}
          listType={listType}
          showTooltip={showTextTooltip}
          tags={tags}
          onClose={props.onCloseTag}
        />
      </Button.White>
    )
  }

  if (type === 'borderless') {
    return (
      <Button.Borderless
        afterIconProps={afterIconProps}
        className={className}
        disabled={disabled}
        elementRef={elementRef}
        height={height}
        isActive={isOpen}
        isSkeleton={isSkeleton}
        qaName={qaName}
        text={text}
        onClick={props.onClick}
      />
    )
  }

  if (type === 'select') {
    return (
      <Button.Select
        afterIconProps={afterIconProps}
        className={className}
        disabled={disabled}
        elementRef={elementRef}
        error={error}
        height={height}
        isActive={isOpen}
        isSkeleton={isSkeleton}
        qaName={qaName}
        showTextTooltip={showTextTooltip}
        text={text}
        textClassName={textClassName}
        tooltip={tooltip}
        onClick={props.onClick}
      />
    )
  }

  return (
    <Button.Contained
      afterIconProps={afterIconProps}
      beforeIconProps={beforeIconProps}
      className={className}
      disabled={disabled}
      elementRef={elementRef}
      height={height}
      isSkeleton={isSkeleton}
      qaName={qaName}
      text={text}
      onClick={props.onClick}
    />
  )
}

export default SelectButton
